import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-privacy-remittance',
  templateUrl: './privacy-remittance.component.html',
  styleUrls: ['./privacy-remittance.component.scss']
})
export class PrivacyRemittanceComponent implements OnInit {
  es = environment.es;
  constructor(
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }
  changeLanguage(language: string) {
    this.authenticationService.setLocale(language);
    this.translate.use(this.getValidLanguage(language));
  }
  getValidLanguage(language: string){
    if (language === 'es' || language === 'en'){
      return language;
    } else {
      return 'en';
    }
  }

}
